import Typography from '@mui/material/Typography'
import { RegularSection, SwiperV3, ColorTitle } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

interface Card {
    link?: string
    image?: string | Record<string, unknown>
    [key: string]: any
}

interface Content {
    title?: string
    subtitle?: string
    cards?: Card[]
}

interface S1_L3_5Props {
    content?: Content
    blockName?:string
}

const Index = (props: S1_L3_5Props) => {
    const { content = {} } = props
    const { title, subtitle, cards = [] } = content
    const normalizedCards = cards.map((card) => {
        const { src } = getImageData(card.image)
        return {
            ...card,
            image: src,
        }
    })
    return (
        <RegularSection aria-label='S1_L3_5' >

            <ColorTitle title={title} colorFrom={1} textAlign='start'/>

            <Typography
                variant='body2'
                sx={{ textAlign: 'center', width: { xs: '90vw', md: '80vw' } }}
            >
                {subtitle}
            </Typography>

            <SwiperV3 cards={normalizedCards}/>
        </RegularSection>
    )
}

export default Index
